import { gql } from '@apollo/client';

export const MEETING_BASIC_INFO = `
  id
  user {
    id
    email
    fullName
    timeZone
  }
  interviewers {
    id
    email
    fullName
  }
  project {
    id
    owners {
      id
    }
    title
    description
    type
    team {
      id
    }
    preInterviewLink
  }
  expert {
    id
    fullName
    title
    organization {
      name
    }
    stripeAccount {
      isConnected
    }
  }
  qualificationResponses {
    question
    response
  }
  invitedAt
  completedAt
  meetingAt
  zoomMeeting {
    id
    meetingLink
  }
  ratingOnExpert
  reviewOnExpert
  overall_status
`;

export const MEETING = gql`
  query Job($id: String!) {
    job(id: $id) {
      ${MEETING_BASIC_INFO}
      zoomMeeting {
        id
        meetingInvite
      }
    }
  }
`;

export const MEETING_INVITE = gql`
  query Job($id: String!) {
    job(id: $id) {
      id
      qualificationResponses {
        question
        response
      }
      project {
        id
        preInterviewLink
      }
      zoomMeeting {
        meetingLink
        meetingInvite
      }
    }
  }
`;

export const MEETING_REPORT = gql`
  query Job($id: String!) {
    job(id: $id) {
      id
      zoomMeeting {
        meetingReport {
          status
          participants {
            name
            email
            joinedAt
            leftAt
            numMinutes
          }
          recordings {
            contentType
            downloadUrl
            playUrl
            content
          }
          summaries {
            title
            overview
            details {
              label
              summary
            }
          }
        }
      }
    }
  }
`;

export const REVIEW_MEETING = gql`
  mutation UpdateJob($userId: ID!, $projectId: ID!, $job: JobInput!) {
    updateJob(userId: $userId, projectId: $projectId, job: $job) {
      id
      ratingOnExpert
      reviewOnExpert
    }
  }
`;

export const RESCHEDULE_MEETING = gql`
  mutation RescheduleMeeting($jobId: ID!, $blockTime: Boolean) {
    rescheduleMeeting(jobId: $jobId, blockTime: $blockTime) {
      id
      overall_status
      meetingAt
    }
  }
`;

export const CANCEL_JOB = gql`
  mutation CancelJob($jobId: ID!, $reason: String!, $blockTime: Boolean) {
    cancelJob(jobId: $jobId, reason: $reason, blockTime: $blockTime) {
      id
      overall_status
      meetingAt
    }
  }
`;

export default MEETING;
